// Sisterhood+ signature track. Update title/artist/artwork/loop here — the
// player and all UI read from this single source. The audio file itself is
// served statically from /public/audio and is never trimmed or altered.
export const SIGNATURE_TRACK = {
  src: "/audio/sisterhood-signature.mp3",
  title: "You Don't Walk Alone",
  artist: "", // intentionally no artist
  artwork: "/images/sisterhood-cover-v3.jpeg",
  loop: true, // signature ambience loops by default
  defaultVolume: 0.35, // comfortable, subtle
};
